export default "__VITE_ASSET__DK51HAzk__"